import { logFactory } from '../../util'
import { useAppointmentsService } from '../services'
import { useQuery } from 'react-query'
import { ReservationsGetManyRequest } from '../../types'

const hookName = 'useReservations'
const log = logFactory(hookName)

const useReservations = (request: ReservationsGetManyRequest, enabled = true) => {
  const { getReservations, isReady } = useAppointmentsService()

  const doQuery = async () => {
    log(`📆 Fetching reservations...`, request)

    const results = await getReservations(request)

    log(`📆 Returned reservations...`, results.data)

    return results.data
  }

  return useQuery([hookName, request], doQuery, {
    enabled: isReady && enabled,
  })
}

export { useReservations, hookName }
